import Glide from 'glidejs';

const blogPromos = () => {
  const blogPromo = document.querySelector('[data-blog-promo-glide]');

  function updateProgressBar(slider) {
    const progressBar = blogPromo.querySelector('.glide__progress-bar');
    const totalSlides = blogPromo.dataset.slideCount;
    const currentIndex = slider.index;
    const progress = (currentIndex / (totalSlides - 1)) * 100;

    progressBar.style.width = `${progress}%`;
  }

  if (blogPromo) {
    const glide = new Glide(blogPromo, {
      perView: 4,
      perTouch: 1,
      gap: 16,
      breakpoints: {
        1024: {
          perView: 2.5
        },
        600: {
          perView: 1.3
        }
      }
    });

    glide.on(['mount.after', 'run'], () => {
      updateProgressBar(glide);
    });

    const mediaQuery = '(max-width: 1024px)';
    const mediaQueryList = window.matchMedia(mediaQuery);

    if (mediaQueryList.matches) {
      glide.mount();
    }

    mediaQueryList.addEventListener('change', event => {
      if (event.matches) {
        glide.mount();
      } else {
        glide.destroy();
      }
    });
  }
};

export default blogPromos();
